import angular from "angular";
export function QpTagsDirective(): ng.IDirective {
    return {
        restrict: "AE",
        require: ["?^ngModel", "qpTags"],
        controllerAs: "ctrl",
        template: require('./qp-tags.template.html').default,
        controller: ["$scope", function ($scope) {
            let ctrl = this;
            ctrl.$onInit = () => {
                // 当前tag是否在编辑
                ctrl.isEdit = false;
            }
        }],
        // 
        link: (scope: angular.IScope, element, attrs, ctrls: angular.IController) => {
            let ngModelCtrl = ctrls[0];
            let selfCtrl = ctrls[1];

            ngModelCtrl.$render = () => {
                // 初始化ng-Model的$modelValue值
                selfCtrl.tagsModel = ngModelCtrl.$modelValue;
            }
            // 默认删除tag方法
            selfCtrl.deleteTag = (targetIndex: number, tagArray:Array<string>) => {
                tagArray.splice(targetIndex, 1);
            }
            // 删除tag，默认删除tag方法（defaultClose）
            selfCtrl.close = attrs.close ? scope.$eval(attrs.close) : selfCtrl.deleteTag;
            // tag最大数量，默认最大数量为5
            selfCtrl.maxSize = attrs.maxSize ? scope.$eval(attrs.maxSize) : 5;
            // tag部分样式,默认样式(qp-tags__tag_default);
            selfCtrl.tagClass = attrs.tagClass ? scope.$eval(attrs.tagClass) : "qp-tags__tag_default";
            // tag 是否只读(布尔值)
            selfCtrl.tagReadonly = attrs.tagReadonly ? scope.$eval(attrs.tagReadonly) : false;
            selfCtrl.saveTag = () => {
                selfCtrl.tagsModel.push(selfCtrl.inputValue);
                selfCtrl.inputValue = undefined;
                selfCtrl.isEdit = false;
            }
        }
    }
}
